import createIcon from '../../createIcon';

/**
 * @component @name EditNotifications
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMDggNi4yNUwxOC44NSA4LjAyTDEzLjg3IDEzSDEyLjFWMTEuMjNMMTcuMDggNi4yNVpNMjAuMzUgNS44MUwxOS4yOSA0Ljc1QzE5LjA5IDQuNTUgMTguNzggNC41NSAxOC41OCA0Ljc1TDE3LjczIDUuNkwxOS41IDcuMzdMMjAuMzUgNi41MkMyMC41NSA2LjMyIDIwLjU1IDYgMjAuMzUgNS44MVpNMTcuNSAxMi4yVjE3SDE5LjVWMTlIMy41VjE3SDUuNVYxMEM1LjUgNy4yMSA3LjQxIDQuODYgMTAgNC4yVjMuNUMxMCAyLjY3IDEwLjY3IDIgMTEuNSAyQzEyLjMzIDIgMTMgMi42NyAxMyAzLjVWNC4yQzEzLjgyIDQuNDEgMTQuNTcgNC43OSAxNS4yMSA1LjI5TDEwLjEgMTAuNFYxNUgxNC43TDE3LjUgMTIuMlpNOS41IDIwSDEzLjVDMTMuNSAyMS4xIDEyLjYgMjIgMTEuNSAyMkMxMC40IDIyIDkuNSAyMS4xIDkuNSAyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditNotifications = createIcon('EditNotifications', [
  [
    'path',
    {
      d: 'M17.08 6.25L18.85 8.02L13.87 13H12.1V11.23L17.08 6.25ZM20.35 5.81L19.29 4.75C19.09 4.55 18.78 4.55 18.58 4.75L17.73 5.6L19.5 7.37L20.35 6.52C20.55 6.32 20.55 6 20.35 5.81ZM17.5 12.2V17H19.5V19H3.5V17H5.5V10C5.5 7.21 7.41 4.86 10 4.2V3.5C10 2.67 10.67 2 11.5 2C12.33 2 13 2.67 13 3.5V4.2C13.82 4.41 14.57 4.79 15.21 5.29L10.1 10.4V15H14.7L17.5 12.2ZM9.5 20H13.5C13.5 21.1 12.6 22 11.5 22C10.4 22 9.5 21.1 9.5 20Z',
      key: '1gy6vk',
    },
  ],
]);

export default EditNotifications;
